import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box
} from '@mui/material';
import styles from './styles.module.scss';
import { ModalData } from '../../types';
import { useTranslation } from 'react-i18next';

interface ModalProps {
  data?: ModalData[];
}

const OfferTableComponent: React.FC<ModalProps> = ({ data }) => {
  const { t } = useTranslation('HbtMasterPoolPricingScenario');
  return (
    <>
      <TableContainer
        className={styles.offerTableContainer}
        component={Paper}
        role="region"
        aria-label={t('offer-table-aria')}
      >
        <Table aria-labelledby="offerTableCaption" className={styles.offTab} stickyHeader>
          <TableHead>
            <TableRow className={styles.offerTableHeader}>
              <TableCell component="th" scope="col" className={styles.leftAlign}>
                {t('scenario')}
              </TableCell>
              <TableCell
                component="th"
                scope="col"
                align="right"
                className={styles.offerTableHeaderCellWithDivider}
              >
                {t('total-premium-and-taxes')}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.map((row: ModalData) => (
              <TableRow key={row.RowName} hover tabIndex={0} className={styles.tableRow}>
                <TableCell className={styles.leftAlign}>{row.RowName}</TableCell>
                <TableCell
                  className={styles.rightAlign}
                  align="right"
                  aria-label={t('premium-and-tax-summary', {
                    value: row.RowAmount
                  })}
                >
                  {row.RowAmount}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box className={styles.offerItems}>
        <div>
          {data?.length} {data && data?.length > 1 ? t('items-count_plural') : t('items-count')}
        </div>
      </Box>
    </>
  );
};

export const OfferTable = React.memo(OfferTableComponent);
